import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@core/environments/environment';
import { Pagination } from '@core/models/pagination.model';
import { LoadingService } from './loading.service';
import { finalize, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FacialRecognitionLogService {
  http = inject(HttpClient);
  BASE_URL = environment.ADMIN_BASE_URL + '/v1';

  loadingService = inject(LoadingService);

  constructor() {}

  getFacialRecognitionLogs(
    data?: Pagination,
    filter?: string
  ): Observable<FacialRecognitionLogsListResponse> {
    const uniqueStateUrl = 'get-face-recognition-log';
    this.loadingService.setLoading(uniqueStateUrl, true);
    let url = '';

    if (filter) {
      url = `${this.BASE_URL}/account/get-face-recognition-log?${filter}`;
    } else {
      url = `${this.BASE_URL}/account/get-face-recognition-log?take=${data?.size}&skip=${data?.skip}`;
    }

    return this.http
      .get<FacialRecognitionLogsListResponse>(url)
      .pipe(
        finalize(() => this.loadingService.setLoading(uniqueStateUrl, false))
      );
  }
}

interface FacialRecognitionLogsListResponse {
  status: string;
  message: string;
  data: {
    data: FacialRecognitionData[];
    total_count: number;
  };
}

export interface FacialRecognitionData {
  id: string;
  name: string;
  time: string;
  reason: string;
  status: string;
  function_type: string;
  user_id: string;
}
